import React from "react";

const Social = ({ data }) => {
    return (


        <div className="flex lg:flex-col lg:text-[20px] max-w-[493px] md:flex-row flex-col md:text-[18px] text-[24px] font-medium px-12 py-6 md:p-6 justify-between lg:gap-6 border-solid rounded-2xl" style={{ color: data.text, backgroundColor: data.bg_social }}>
            <span className="relative text-[24px] md:hidden before:content-['•'] before:absolute before:left-[-1.5rem] before:top-0"></span>
            <a href={data.tg_channel_Link} target="blank">{data.tg_channel}</a>

            <span className="relative lg:hidden md:block hidden mx-1 text-[24px] before:content-['•'] before:absolute before:left-[-0.5rem] before:-top-1"></span>
            <span className="relative text-[24px] md:hidden before:content-['•'] before:absolute before:left-[-1.5rem] before:top-0"></span>
            <a href={data.tg_chat_Link} target="blank">{data.tg_chat}</a>

            <span className="relative lg:hidden md:block hidden mx-1 text-[24px] before:content-['•'] before:absolute before:left-[-0.5rem] before:-top-1"></span>
            <span className="relative text-[24px] md:hidden before:content-['•'] before:absolute before:left-[-1.5rem] before:top-0"></span>
            <a href={data.vkLink} target="blank">{data.vk}</a>

            <span className="relative lg:hidden md:block hidden mx-1 text-[24px] before:content-['•'] before:absolute before:left-[-0.5rem] before:-top-1"></span>
            <span className="relative text-[24px] md:hidden  before:content-['•'] before:absolute before:left-[-1.5rem] before:top-0"></span>
            <a href="https://vc.ru/u/4015363-ulaglobal" target="blank">{data.vc}</a>
        </div>

    );
};

export default Social;